import clsx from 'clsx';
import { PROCESSES_SUGGESTION_TYPE } from 'gcs-common/constants/processesSuggestionType';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import type { ProcessesState } from 'gcs-common/slices/processes/processesSlice';
import { type ChangeEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';
import exitIcon from '../../img/close.svg';
import styles from './styles.module.scss';

interface SearchBarProps {
  filter: ProcessesState['filter'];
  onSearchInputChange: (arg0: ChangeEvent<HTMLInputElement>) => void;
  searchInput: string;
  resetFilter: VoidFunction;
  placeholder: string;
  className?: string | undefined;
}

const SearchBar = (props: SearchBarProps) => {
  const { filter, onSearchInputChange, searchInput, resetFilter, placeholder = 'Suchen...', className } = props;

  const [inputValue, setInputValue] = useState(searchInput);

  const selectedChannelId: string = useSelector(getSelectedChannelId);
  useEffect(() => {
    setInputValue('');
  }, [selectedChannelId]);

  const [updateSearchInputValueDebounced] = useDebouncedCallback(($event: ChangeEvent<HTMLInputElement>) => {
    onSearchInputChange($event);
  }, 500);

  const onChange = ($event: ChangeEvent<HTMLInputElement>) => {
    const { value } = $event.target;
    setInputValue(value);
    updateSearchInputValueDebounced($event);
  };

  return (
    <div className={clsx(styles.search, className)}>
      <input
        className={styles.searchInput}
        placeholder={placeholder}
        type="search"
        value={inputValue}
        onChange={onChange}
      />
      {filter && (
        <button type="button" className={styles.filter}>
          <div>
            <div className={styles.suggestion}>{filter.name}</div>
            <div className={styles.suggestionType}>{PROCESSES_SUGGESTION_TYPE[filter.type]}</div>
          </div>
          <button type="button" onClick={resetFilter}>
            <img src={exitIcon} className={styles.filterClose} alt="exit-icon" />
          </button>
        </button>
      )}
    </div>
  );
};

export default SearchBar;
